import _ from 'lodash';
import { createQueryParams } from '@nexio/emvio-util-app';
import config from '../../config/config';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';
import { prettifyMoney, prettifyNumber } from '@nexio/emvio-util-app';

export const AGENT_RESIDUALS_TOTAL_LOAD = 'AGENT_RESIDUALS/AGENT_RESIDUALS_TOTAL_LOAD';
export const AGENT_RESIDUALS_TOTAL_SUCCESS = 'AGENT_RESIDUALS/AGENT_RESIDUALS_TOTAL_SUCCESS';
export const AGENT_RESIDUALS_TOTAL_FAILURE = 'AGENT_RESIDUALS/AGENT_RESIDUALS_TOTAL_FAILURE';
export const AGENT_RESIDUALS_LOAD = 'AGENT_RESIDUALS/AGENT_RESIDUALS_LOAD';
export const AGENT_RESIDUALS_SUCCESS = 'AGENT_RESIDUALS/AGENT_RESIDUALS_SUCCESS';
export const AGENT_RESIDUALS_FAILURE = 'AGENT_RESIDUALS/AGENT_RESIDUALS_FAILURE';

export const fetchUrl = `${config.residualApiUrl}/reseller/agent`;

export function getAgentResidualsTotal(filters, agentId) {
    const queryParamsString = createQueryParams({
        dateKey: 'reportDate',
        filters: [...filters, {
            id: 'agentId',
            value: agentId
        }]
    });

    return {
        failureActionTypeOrCreator: getAgentResidualsTotalFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: AGENT_RESIDUALS_TOTAL_LOAD,
        successActionTypeOrCreator: getAgentResidualsTotalSuccessActionCreator
    };
}

export function getAgentResidualsTotalSuccessActionCreator(results) {
    const agentName = _.get(results, 'agentName');
    const merchants = prettifyNumber(_.get(_.last(results.rows), 'merchantCount'));
    const authCount = prettifyNumber(_.sumBy(results.rows, 'authCount'));
    const volume = prettifyMoney(_.sumBy(results.rows, 'volume'));
    const income = prettifyMoney(_.sumBy(results.rows, 'income'));
    const expense = prettifyMoney(_.sumBy(results.rows, 'expense'));
    const grossResidual = prettifyMoney(_.sumBy(results.rows, 'grossResidual'));
    const agentResidual = prettifyMoney(_.sumBy(results.rows, 'agentResidual'));

    const summaryResults = {
        agentName,
        merchants,
        authCount,
        volume,
        income,
        expense,
        grossResidual,
        agentResidual
    };

    return {
        summaryResults,
        type: AGENT_RESIDUALS_TOTAL_SUCCESS
    };
}

export function getAgentResidualsTotalFailureActionCreator(error) {
    return {
        error,
        type: AGENT_RESIDUALS_TOTAL_FAILURE
    };
}

export function getAgentResiduals(filters, page, pageSize, sorters, agentResidualsId) {
    const queryParamsString = createQueryParams({
        dateKey: 'reportDate',
        filters,
        page,
        pageSize,
        sorters
    });

    return {
        failureActionTypeOrCreator: getAgentResidualsFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}/${agentResidualsId}${queryParamsString}`
        },
        loadActionTypeOrCreator: AGENT_RESIDUALS_LOAD,
        successActionTypeOrCreator: getAgentResidualsSuccessActionCreator
    };
}

export function getAgentResidualsSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, AGENT_RESIDUALS_SUCCESS, 'agentResiduals');
}

export function getAgentResidualsFailureActionCreator(error) {
    return {
        error,
        type: AGENT_RESIDUALS_FAILURE
    };
}

